import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Efficiency">
                            <h2>Inducing Efficiency In Your System, Making It World-Class</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>Efficiency is the core of business performance. TekRevol relies on the processes and their implementation to allow your business to pivot and achieve bigger and better. Our understanding of the digital world keeps us ahead, which we leverage to deliver extraordinarily for our clients.</p>
                        <p>We drive efficiency through effective process development and an intelligent strategic and technology approach to make situations more conducive for you and your business. From organizational excellence to increased ROI, our plans provide you with the leap you have envisioned.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;